// Small display-only helpers shared by the Report tab views. These derive
// percentages/rankings from data the report already returns — they never
// fetch or compute new report metrics.

export const pickValue = (item) => Number(item?.value ?? item?.spend ?? item?.score) || 0

export const sortByValueDesc = (items = []) => [...items].sort((a, b) => pickValue(b) - pickValue(a))

// e.g. "6 entries · Top: IT Equipment (32.4%)" — built purely from the items
// array already present in the report response.
export const topContributorSummary = (items = []) => {
  if (!items.length) return undefined
  const total = items.reduce((sum, i) => sum + pickValue(i), 0)
  const [top] = sortByValueDesc(items)
  const pct = total > 0 ? ((pickValue(top) / total) * 100).toFixed(1) : "0.0"
  return `${items.length} ${items.length === 1 ? "entry" : "entries"} · Top: ${top.name} (${pct}%)`
}
